import style from './StageQualityStartModal.module.css';

import Modal from 'ui/Modal';
import Model from './Model';
import { FormProvider, useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { productionStore } from 'store/mobx/production.store';
import useAlert from 'hooks/useAlert';
import Objects from './Objects';

const StageQualityStartModal = ({ setOpen, open, node }) => {
  const { showAlert } = useAlert();
  const formContext = useForm();

  const { startProcessIteration } = productionStore;
  const { handleSubmit, reset } = formContext;
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  const closeModal = () => {
    reset();
    setOpen(false);
  };

  const onSubmit = async (data) => {
    data.params = {
      ...data.params,
      type: 'quality_control',
    };

    setLoader(true);
    const res = await startProcessIteration(node?.id, data);
    if (res.status) closeModal();
    else showAlert(res.message, 'error');
    setLoader(false);
  };

  return (
    <Modal
      title="Запустить этап производства"
      onClose={closeModal}
      onSubmit={handleSubmit(onSubmit)}
      open={open}
      submitText="Запустить"
      disabledSubmit={loader}
    >
      <FormProvider {...formContext}>
        <div>
          <div className={style.formBody}>
            <Objects objects={node?.objects} />
          </div>
          {node?.protocol?.length > 0 && <div className={style.title}>Модели</div>}
          {node?.protocol?.device_models?.map((model, index) => {
            return <Model key={model.id} model={model} index={index} />;
          })}
        </div>
      </FormProvider>
    </Modal>
  );
};

export default StageQualityStartModal;
